import template from './templates/menu-button.tpl.html';
const ARROW_LEFT = 20;
const ARROW_WIDTH = 22;

function menuButton(translateValueSupport) {
  return {
    restrict: 'E',
    replace: true,
    transclude: {
      'menu-trigger': '?akamMenuButtonTrigger'
    },
    template,
    scope: {},
    bindToController: {
      position: '@?',
      size: '@?',
      onClick: '&?',
      text: '@?',
      defaultText: '@?',
      isDisabled: '=?'
    },
    controller: () => ({
      onToggle(isOpen) {
        if (isOpen && this.hasCustomTrigger) {
          const triggerWidth = Math.round(this.customTriggerEl.getBoundingClientRect().width);
          const marginCorrection = ARROW_LEFT + ARROW_WIDTH / 2 - triggerWidth / 2;

          if (typeof this.position === 'undefined' || this.position === 'left') {
            // Left menus only need to nudge further left when trigger is too narrow
            if (marginCorrection > 0) {
              this.menuWrapperEl.style.marginLeft = `-${marginCorrection}px`;
            }
          } else {
            // Right menus will need to nudge further right if the trigger is too narrow
            const menuElement = this.menuWrapperEl.querySelector(':scope > .dropdown-menu');
            const menuRight = Math.round(menuElement.getBoundingClientRect().right);
            if (marginCorrection > 0) {
              this.menuWrapperEl.style.marginRight = `-${marginCorrection}px`;
            }
            // Right menus also need to position the arrow to near the right edge
            const menuWrapperLeft = Math.round(this.menuWrapperEl.getBoundingClientRect().left);
            const marginLeftPx = menuRight - menuWrapperLeft - ARROW_LEFT -
              (marginCorrection > 0 ? 0 : ARROW_WIDTH);
            this.menuWrapperEl.style.marginLeft = `${marginLeftPx}px`;
          }
        } else if (this.hasCustomTrigger) {
          this.menuWrapperEl.style.marginLeft = 0;
          this.menuWrapperEl.style.marginRight = 0;
        }
      }
    }),
    controllerAs: 'menuButton',
    link(scope, elem, attr, ctrl) {
      ctrl.customTriggerEl = elem[0].querySelector('div.akam-menu-button-custom-trigger');
      ctrl.menuWrapperEl = elem[0].querySelector('.dropdown-wrapper');
      ctrl.hasCustomTrigger = !!ctrl.customTriggerEl;

      translateValueSupport.setValues(scope.menuButton, 'defaultText', attr.defaultTextValues);
      switch (attr.size) {
        case 'small':
          scope.menuButton.btnSize = 'btn-sm';
          break;
        case 'large':
          scope.menuButton.btnSize = 'btn-lg';
          break;
      }
    }
  };
}
menuButton.$inject = ['translateValueSupport'];

export default menuButton;
